import React from 'react';
import PropTypes from 'prop-types';

import Model from './Model';

import bannerCircleBlue from './banner_box_circle-blue.jpg';
import bannerCircleRed from './banner_box_circle-red.jpg';
import bannerRectangleBlue from './banner_box_rectangle-blue.jpg';
import bannerRectanglePurple from './banner_box_rectangle-purple.jpg';
import bannerRectangleYellow from './banner_box_rectangle-yellow.jpg';

const banners = {
  'circle-blue': bannerCircleBlue,
  'circle-red': bannerCircleRed,
  'rectangle-blue': bannerRectangleBlue,
  'rectangle-purple': bannerRectanglePurple,
  'rectangle-yellow': bannerRectangleYellow,
};

class FlavourBlock extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      modal: {
        show: false,
        className: ''
      }
    };
  }
  handleOpenModal = (className) => {
    this.setState({
      modal: {
        className,
        show: true,
      }
    });
  }
  handleCloseModal = () => {
    this.setState({
      modal: {
        ...this.state.modal,
        show: false,
      }
    });
  }
  render() {
    const { tt: { flavour } } = this.props;
    const categories = Object.keys(flavour.categories);
    return (
      <div className="block flavour" id="flavour">
        {
          this.state.modal.show &&
          <Model
            onClose={this.handleCloseModal}
            className={this.state.modal.className}
          />
        }
        <div className="container">
          <div className="subject title">{flavour.title}</div>
          <div
            className="text large"
            dangerouslySetInnerHTML={{
              __html: flavour.text
            }}
          />
          <div className="cookie-chooser">
            {categories.map((category, i) => (
              <input
                name="cookie-chooser"
                id={category}
                key={`radio-${category}`}
                type="radio"
                defaultChecked={i === 0}
              />
            ))}
            <div />
            <ul>
              {categories.map(category => (
                <li key={`tab-${category}`} className={category}>
                  <label
                    htmlFor={category}
                    className={`tab ${category}`}
                  />
                </li>
              ))}
            </ul>
            {categories.map(category => (
              <div
                key={`content-${category}`}
                className={`content ${category}`}
              >
                <div className="cookie-list-wrapper">
                  <ul className="cookie-list">
                    {flavour.categories[category].map((cookie, i) => (
                      <li className="cookie" key={`cookie-${category}-${i + 1}`}>
                        <div
                          className={`image image-${i + 1}`}
                          onClick={() => this.handleOpenModal(`${category}-${i + 1}`)}
                        />
                        <div className="name">
                          {flavour.categories[category][i].name}
                        </div>
                        <div className="text">
                          {flavour.categories[category][i].text}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
                <img className="banner" src={banners[category]} alt="" />
              </div>
            ))}
          </div>
          <a href="https://mrrichbakery.myshopify.com" className="order-now">
            {flavour.orderNow}
          </a>
        </div>
      </div>
    );
  }
}

FlavourBlock.propTypes = {
  tt: PropTypes.object,
};

FlavourBlock.defaultProps = {
  tt: {},
};

export default FlavourBlock;



// WEBPACK FOOTER //
// ./src/HomePage/blocks/FlavourBlock/index.js